


























































import { defineComponent, reactive } from "@vue/composition-api";
import { Button, SortableTable } from "@micad/vue-components";
import { connectionsColumns } from "@/assets/js/constants";
import { Connection, getConnections } from "@/data/repos/connectionList";
import { displayRequestStatus } from "@/notifications";
import Loading from "@/components/Loading.vue";
import { userDisconnect } from "@/data/repos/userDisconnect";
import { canIUse } from "@/modules/auth";
import { localeDateTimeFormat } from "@/modules/dates";

export default defineComponent({
  methods: { canIUse },
  components: {
    SortableTable,
    Button,
    Loading,
  },
  setup() {
    const connections = [] as Connection[];
    setTimeout(async () => {
      state.loaded = false;
      const resp = await getConnections();
      displayRequestStatus(resp, "", "Internal server error.");
      if (resp.ok) {
        connections.push(
          ...(resp.payload || [])
            .sort((a: Connection, b: Connection) =>
              a.userName.toLowerCase() > b.userName.toLowerCase() ? 1 : -1
            )
            .map((r) => ({
              ...r,
              lastActiveTs: localeDateTimeFormat(r.lastActiveTs),
            }))
        );
      }
      state.loaded = true;
    }, 0);
    const state = reactive({
      connections,
      disconnectMode: false,
      max: 1,
      connectionsColumns,
      loaded: false,
      disconnect(connections: Connection[]) {
        console.log(connections);
        connections.forEach(async (c) =>
          displayRequestStatus(
            await userDisconnect(c.userId),
            `${c.userName} disconnected`
          )
        );
      },
    });
    return state;
  },
});
